export const timerQue: { [key: string]: ReturnType<typeof setTimeout> } = {};

export const debounce = (id: string, callback: () => void, dilay: number) => {
    if (timerQue[id]) clearTimeout(timerQue[id]);
    timerQue[id] = setTimeout(callback, dilay);
};
